import { render, staticRenderFns } from "./bloqueo.vue?vue&type=template&id=b4d26f8a&"
import script from "./bloqueo.vue?vue&type=script&lang=js&"
export * from "./bloqueo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./bloqueo.vue?vue&type=custom&index=0&blockType=tyle"
if (typeof block0 === 'function') block0(component)

export default component.exports